import { QueryClient } from '@tanstack/react-query'

/**
 * Configure React Query client with standard settings
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Standard React Query defaults
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 0,
      gcTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      retry: false,
    },
  },
})

export default queryClient
